import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { Text } from '@naf/text';
import { colors } from '@naf-simba/theme';

export const LogoArea = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StyledTopText = styled(Text)`
  font-size: 1rem;
  line-height: 1.125rem;

  @media (max-width: ${breakpoints.m}) {
    font-size: 0.875rem;
    line-height: 1.125rem;
  }
`;

export const StyledBottomText = styled(Text)`
  font-size: 1rem;
  line-height: 1.125rem;
  font-weight: 700;
`;

export const RoadAssistance = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: ${nafColor.signature.black};
  margin: 0 0 0 ${spacing.space8};
  white-space: nowrap;

  &:hover {
    span {
      color: ${colors.secondary[500]} !important;
    }
  }

  @media (max-width: ${breakpoints.m}) {
    margin-left: ${spacing.space8};
  }
`;

export const SeparatorLine = styled.div`
  width: 1px;
  height: 40px;
  background-color: ${nafColor.signature.yellow};
  margin: 0 ${spacing.space16};

  @media (max-width: ${breakpoints.l}) {
    display: none;
  }
`;
